import { executeCapability } from '../utils/capabilityExecute'

export type KioskDeviceRecord = {
  id: string
  name: string
  accessLevel: string
  keyPrefix: string
  enabled: boolean
  lastUsedAt: string | null
  createdBy: string | null
  updatedBy: string | null
  createdAt: string | null
  updatedAt: string | null
}

export type CreateOrRotateDeviceResult = {
  deviceKey: string
  device: KioskDeviceRecord
  warning: string
}

export const kioskDevicesService = {
  async list(): Promise<KioskDeviceRecord[]> {
    const out = await executeCapability<{ data: KioskDeviceRecord[] }>({
      app: 'admin',
      capability: 'kioskDevices.list',
      input: {},
    })
    return out?.data || []
  },

  async create(input: {
    name: string
    accessLevel: string
  }): Promise<CreateOrRotateDeviceResult> {
    return executeCapability<CreateOrRotateDeviceResult>({
      app: 'admin',
      capability: 'kioskDevices.create',
      input,
    })
  },

  async update(input: {
    id: string
    name?: string
    accessLevel?: string
    enabled?: boolean
  }): Promise<KioskDeviceRecord> {
    const out = await executeCapability<{ device: KioskDeviceRecord }>({
      app: 'admin',
      capability: 'kioskDevices.update',
      input,
    })
    return out.device
  },

  async rotate(id: string): Promise<CreateOrRotateDeviceResult> {
    return executeCapability<CreateOrRotateDeviceResult>({
      app: 'admin',
      capability: 'kioskDevices.rotate',
      input: { id },
    })
  },

  async delete(id: string): Promise<KioskDeviceRecord> {
    const out = await executeCapability<{ device: KioskDeviceRecord }>({
      app: 'admin',
      capability: 'kioskDevices.delete',
      input: { id },
    })
    return out.device
  },
}
